import React, { Component } from "react";
import { connect } from "react-redux";
import "./App.css";
import { LANGUAGES, LANGUAGES_CODE } from "./utils/constants";
import { withLocalize, getTranslate } from "react-localize-redux";
import { renderToStaticMarkup } from "react-dom/server";
import DisplayContainer from "./containers/DisplayContainer.js";
import json_en from "./translations/en.json";
import json_fi from "./translations/fi.json";
import json_sv from "./translations/sv.json";
import * as configurationThunks from "./redux/thunks/configurationThunks";
import * as orderThunks from "./redux/thunks/orderThunks";
import GlobalShortcutsContainer from "./containers/GlobalShortcutContainer";
import SettingsContainer from "./containers/SettingsContainer";
import ErrorNotificationContainer from "./containers/ErrorNotificationContainer";
import { getQueryStringValues } from "./utils/helpers";
import { saveConfiguration } from "./redux/actions/configurationActions";
import { signalRStart } from "./middleware/signalRMiddleware";

class App extends Component {
  componentWillMount = () => {
    let qsValues = getQueryStringValues();

    if (
      !this.props.kitchenServiceAddress &&
      qsValues &&
      qsValues.kitchenService &&
      qsValues.kitchenService.startsWith("http://")
    ) {
      this.props.saveConfiguration({
        kitchenServiceAddress: qsValues.kitchenService,
        showPreparationView: true,
        showReadyToPickUpView: true
      });
      signalRStart();
    }

    this.props.getLanguage();
    this.props.getState();
  };

  constructor(props) {
    super(props);

    const onMissingTranslation = () => {
      return "Unexpected problem with display!";
    };

    this.props.initialize({
      languages: LANGUAGES,
      options: {
        renderToStaticMarkup,
        defaultLanguage: "en",
        onMissingTranslation
      }
    });

    this.props.addTranslationForLanguage(json_en, LANGUAGES_CODE.EN);
    this.props.addTranslationForLanguage(json_fi, LANGUAGES_CODE.FI);
    this.props.addTranslationForLanguage(json_sv, LANGUAGES_CODE.SV);

    this.props.setActiveLanguage(this.props.languageCode);
  }

  render() {
    return (
      <GlobalShortcutsContainer>
        {this.props.configurationMode && <SettingsContainer />}
        {!this.props.configurationMode && <DisplayContainer />}
        <ErrorNotificationContainer
          kitchenConnectionUp={this.props.kitchenConnectionUp}
          lastServiceError={this.props.lastServiceError}
          translate={this.props.translate}
        />
      </GlobalShortcutsContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    translate: getTranslate(state.localize),
    languageCode: state.configuration.languageCode,
    configurationMode: state.configuration.configurationMode,
    kitchenConnectionUp: state.configuration.kitchenConnectionUp,
    lastServiceError: state.notification.lastServiceError,
    kitchenServiceAddress: state.configuration.kitchenServiceAddress
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLanguage: () => dispatch(configurationThunks.getLanguage()),
    getState: () => dispatch(orderThunks.getState()),
    saveConfiguration: kitchenAddress =>
      dispatch(saveConfiguration(kitchenAddress))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize(App));



// WEBPACK FOOTER //
// ./src/App.js